import { render, staticRenderFns } from "./NewCommentControls.vue?vue&type=template&id=0aded33c"
import script from "./NewCommentControls.vue?vue&type=script&lang=js"
export * from "./NewCommentControls.vue?vue&type=script&lang=js"
import style0 from "./NewCommentControls.vue?vue&type=style&index=0&id=0aded33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports